import React from 'react';
import styles from './FAQ.module.css';

const FAQ = ({ title = 'FAQs', description, items }) => {
  return (
    <div className={styles.accordion}>
      <div className={styles.accordion__header}>
        <h2 className={styles.accordion__title}>{title}</h2>
        {description && <p className={styles.accordion__description}>{description}</p>}
      </div>

      <div className={styles.accordion__list}>
        {items.map((item, index) => (
          <details key={index} className={styles.accordion__item}>
            <summary className={styles.accordion__summary}>
              <span className={styles.accordion__question}>{item.title}</span>
              <span className={styles.accordion__icon}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 12L16 20L24 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </summary>
            <div className={styles.accordion__content}>
              <div className={styles['accordion__content-inner']}>
                <p className={styles.accordion__answer}>{item.content}</p>
              </div>
            </div>
          </details>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
